import store from '@/state/store';
import { registration } from '@/api/auth';
import registrationSlice from '@/state/registration.slice';
import { RegistrationStatus } from '@/contracts';
import { RegistrationRequest } from '@bimdata/definitions/dto';
import authenticationSlice from '@/state/authentication.slice';
import { handleError } from '../common';
import { ApiError } from '@bimdata/client';
import { RegistrationErrorCodes } from '@bimdata/definitions/errors/registration.error';

export default async (data: RegistrationRequest) => {
  const state = store.getState();
  if (state.registration.status !== RegistrationStatus.PENDING) {
    throw new Error('Action cannot be performed.');
  }

  store.dispatch(registrationSlice.actions.startRegistration({ withPhone: !!data.phone }));
  try {
    const claim = await registration(data);
    store.dispatch(registrationSlice.actions.finishRegistration(claim));
    store.dispatch(authenticationSlice.actions.startEmailVerification());
  } catch (error) {
    if (error instanceof ApiError && error.code === 400 && error.exceptionCode === RegistrationErrorCodes.EMAIL_ALREADY_EXISTS) {
      store.dispatch(registrationSlice.actions.fakeFinishRegistration());
      return;
    }
    store.dispatch(registrationSlice.actions.rejectRegistration());
    handleError(error);
  }
};
